import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import moment from "moment";
import { ContentDivider, LinkWrapper, DateSelector } from "../../style";
import {
  LabelDataHead,
  ValueDataHeading,
  LinkHeading,
} from "../RenderCard/style";
import { Wrapper } from "./styles";
import CurrencyInput from "../../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import formatter from "../../../../../../utils/formatter";
import { statusChecker } from "../../utils";

const grantAmountRender = ({
  value,
  record,
  i,
  handleInputChange,
  handleInputBlur,
}) =>
  statusChecker(record.status) ? (
    <Wrapper Input>
      <CurrencyInput
        name="amount"
        aria-label="Grant amount"
        maxLength={150}
        onChange={(e) => handleInputChange(i, e)}
        value={value}
        onBlur={(e) => handleInputBlur(e)}
      />
    </Wrapper>
  ) : (
    <ValueDataHeading>
      {formatter({ value, fieldSuffix: "Dollars" })}
    </ValueDataHeading>
  );

const scheduleDateRender = ({ value, record, i, dateChangeHandle }) =>
  value ? (
    statusChecker(record.status) ? (
      <DateSelector
        name="date"
        format="MM/DD/YYYY"
        onChange={(e, date) => dateChangeHandle(e, date, i)}
        value={value ? moment(value) : null}
      />
    ) : (
      <ValueDataHeading>{value}</ValueDataHeading>
    )
  ) : (
    <div>&mdash;</div>
  );

const RecurringEditableCard = (props) => {
  const {
    data,
    index,
    editedSpawns,
    resetHandler,
    individualCancelHandler,
    handleInputChange,
    handleInputBlur,
    dateChangeHandle,
  } = props;

  return (
    <div>
      <Row>
        <Col span={24}>
          <LinkHeading>{data.grantName}</LinkHeading>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <LabelDataHead>Grant Amount</LabelDataHead>
          <ValueDataHeading>
            {grantAmountRender({
              value: data.amount,
              record: data,
              i: index,
              handleInputChange: handleInputChange,
              handleInputBlur: handleInputBlur,
            })}
          </ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHead>Scheduled Issue Date</LabelDataHead>
          <ValueDataHeading>
            {scheduleDateRender({
              value: data.scheduledDate,
              record: data,
              i: index,
              dateChangeHandle: dateChangeHandle,
            })}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider small />
      <Row>
        <Col span={12}>
          <LabelDataHead>Status</LabelDataHead>
          <ValueDataHeading>
            {data.status ? data.status : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHead>Issue Date</LabelDataHead>
          <ValueDataHeading>
            {data.issueDate ? data.issueDate : <div>&mdash;</div>}
          </ValueDataHeading>
        </Col>
      </Row>
      {statusChecker(data.status) ? <ContentDivider small /> : <div />}
      <Row>
        <Col span={24}>
          {editedSpawns && editedSpawns.includes(data.spawnId) ? (
            <LinkWrapper onClick={() => resetHandler(data, index)}>
              Reset
            </LinkWrapper>
          ) : statusChecker(data.status) ? (
            <LinkWrapper onClick={() => individualCancelHandler(data, "spawn")}>
              Cancel
            </LinkWrapper>
          ) : (
            <div />
          )}
        </Col>
      </Row>
    </div>
  );
};

RecurringEditableCard.propTypes = {
  data: PropTypes.shape({
    allocationType: PropTypes.string,
    amount: PropTypes.string,
    checkNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    grantAllocation: PropTypes.array,
    grantName: PropTypes.string,
    issueDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scheduledDate: PropTypes.string,
    spawnId: PropTypes.number,
    status: PropTypes.string,
  }),
  dateChangeHandle: PropTypes.func,
  editedSpawns: PropTypes.array,
  handleInputBlur: PropTypes.func,
  handleInputChange: PropTypes.func,
  index: PropTypes.number,
  individualCancelHandler: PropTypes.func,
  resetHandler: PropTypes.func,
};

export default RecurringEditableCard;
